import PropTypes from 'prop-types';
import {buildHandleEnterKeyPress} from '../utils/accessibility';

const OptionButton = ({children, disabled, highlighted, id, name, onClick, selected, style, tabIndex, className}) => {
  const handleClick = (event) => {
    event.preventDefault();
    if (!disabled) onClick();
  };

  const baseClasses = [
    'flex',
    'flex-col',
    'items-center',
    'justify-center',
    'text-center',
    'rounded-lg',
    'border',
    'w-full',
    'relative',
    'outline-hidden',
    'cursor-pointer',
    'transition-colors',
  ];

  const stateClasses = [];

  if (disabled) {
    stateClasses.push(
      'bg-lightest-gray',
      'border-medium-gray',
      'text-gray-500',
      'pointer-events-none',
      'cursor-not-allowed'
    );
  } else if (selected) {
    stateClasses.push('bg-blue', 'border-[#00aeef]', 'text-white');
  } else if (highlighted) {
    stateClasses.push('border-[#00aeef]', 'text-blue');
  }

  const hoverClasses = disabled ? '' : 'hover:bg-blue hover:text-white!';

  const finalClassName = [...baseClasses, ...stateClasses, hoverClasses, className].filter(Boolean).join(' ');

  return (
    <label
      className={finalClassName}
      data-cy={`select-${name}`}
      htmlFor={id}
      onClick={handleClick}
      onKeyPress={buildHandleEnterKeyPress(onClick)}
      style={style}
      tabIndex={tabIndex}>
      <input className="absolute invisible" id={id} name={name} type="checkbox" />
      {children}
    </label>
  );
};

OptionButton.propTypes = {
  caption: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.node]).isRequired,
  disabled: PropTypes.bool,
  highlighted: PropTypes.bool,
  id: PropTypes.string,
  name: PropTypes.string,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
  style: PropTypes.object,
  tabIndex: PropTypes.number,
  className: PropTypes.string,
};

OptionButton.defaultProps = {
  caption: '',
  disabled: false,
  highlighted: false,
  id: '',
  name: '',
  onClick: () => {},
  selected: false,
  style: {},
  tabIndex: 0,
  className: '',
};

export default OptionButton;
